import styled from 'styled-components';

export const SwitchWrapper = styled.label`
  display: inline-block;
  width: 32px;
  height: 18px;
  position: relative;
  margin-left: 10px;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const Slider = styled.span<{ checked: boolean }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) => (props.checked ? '#ffe082' : '#f5f5f5')};
  border-radius: 18px;
  transition: 0.4s;
  &:before {
    position: absolute;
    content: '';
    height: 14px;
    width: 14px;
    left: 2px;
    bottom: 2px;
    background-color: ${(props) => (props.checked ? '#ffc107' : '#9e9e9e')};
    transition: 0.4s;
    border-radius: 50%;
    transform: ${(props) => (props.checked ? 'translateX(14px)' : 'none')};
  }
`;
